<template>
    <div :id="'worksends-menu-'+menuName" class="worksends-menu-section" ref="mainMenu">
        <template v-for="(link, slug) in menuLinks">
            <div :key="slug" v-if="showThisMenuItem(link)" @mouseover="onMenuHover"
                 :class="getClasses({ slug, baseClass: 'worksends-menu-item worksends-menu-item-' })">
                <router-link class="worksends-menu-item-link" :to="`/${slug}`">
                    {{ link.title }}
                    <span v-if="link.tag" :class="'link-tag link-tag-'+link.tag">{{ link.tag }}</span>
                </router-link>
				<tutorial-tooltip v-if="showTutorial(4) && slug === 'campaigns'" location="marketplace" tooltip="brand-the-experience"></tutorial-tooltip>
				<tutorial-tooltip v-if="showTutorial(6) && slug === 'settings'" location="marketplace" tooltip="preferences"></tutorial-tooltip>
				<tutorial-tooltip v-if="showTutorial(7) && slug === 'campaigns'" location="marketplace" tooltip="campaigns"></tutorial-tooltip>
				<tutorial-tooltip v-if="showTutorial(8) && slug === 'campaigns'" location="marketplace" tooltip="corporate-products"></tutorial-tooltip>

                <div v-else-if="link.submenu"
                     :class="getClasses({ slug, baseClass: 'worksends-submenu worksends-submenu-' })"
                     :data-parent="slug">
                    <template v-if="showThisMenuItem(link)">
                        <router-link v-for="(link, slug) in link.submenu"
                                     :key="slug" v-if="showThisMenuItem(link)"
                                     :class="getClasses({ slug, baseClass: 'worksends-submenu-item worksends-submenu-item-', subMenuItem: true })"
                                     :to="`/${slug}`"
                        >
                            {{ link.title }}
                        </router-link>
                        <tutorial-tooltip v-if="showTutorial(1)" location="marketplace" tooltip="e-gifts"></tutorial-tooltip>
						<tutorial-tooltip v-if="showTutorial(5)" location="marketplace" tooltip="order-history"></tutorial-tooltip>
                    </template>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import TutorialTooltip from "@/components/modals/TutorialTooltip";

export default {
    name: 'WSMenu',
    components: { TutorialTooltip },
    props: {
        menuName: { required: true, type: String },
        menuLinks: { required: true, type: Object } 
    },
	data() {
		return {
			windowWidth: window.innerWidth,
		}
	},
    methods: {
        getClasses({ slug = '', baseClass = '', subMenuItem = false, data = {} }) {
            let classes = [baseClass + slug];
            if (
                (baseClass.includes('worksends-submenu ') || baseClass.includes('worksends-menu-item '))
                && this.$route.path.startsWith(`/${slug}`)
			) {
                classes.push('active');
            }

            if (
                this.$route.params.survey_id !== undefined
                && this.$route.path.includes(`/surveys/${this.$route.params.survey_id}/`)
                && slug === 'surveys/dashboard'
            ) {
                classes.push('active');
            }

			if ((
                    baseClass.includes('worksends-submenu-item ')
				    && this.$route.path === (`/${slug}`)
                ) ||
                (
                    slug === 'campaigns'
                    && 'campaignId' in data
                    && ([(`/${slug}/${data.campaignId}`), (`/${slug}/${data.campaignId}/analytics`)].includes(this.$route.path))
                )) {
				classes.push('submenu-active');
			}

            if (['campaigns','corporate-products'].includes(slug) && !this.demo.isDemo && this.team.plan!='pro') {
                classes.push('preview');
            }

            if (
				(this.showTutorial(1) && slug === 'marketplace/digital')
				|| (this.showTutorial(4) && slug === 'campaigns')
				|| (this.showTutorial(5) && slug === 'marketplace/orders')
				|| (this.showTutorial(6) && slug === 'settings')
				|| (this.showTutorial(7) && slug === 'campaigns')
				|| (this.showTutorial(8) && slug === 'campaigns')
			) {
				classes.push('in-tutorial');
			}

            classes = classes.map(slug => slug.replaceAll('/', '-'));
            return classes;
        },
        showThisMenuItem(link) {
            if (link.permission) {
                if (!Array.isArray(this.currentUser.permissions)) return false;
                if (!this.currentUser.permissions.includes(link.permission)) return false;
            }
            if (link.requires && link.requires.includes('oms') && !this.team.oms_customer_id) return false;
            if (link.plans && !link.plans.includes((this.team.plan))) return false;
            if (link.teams && link.teams.length && !link.teams.includes(this.teamSlug)) return false;
            return true;
        },
        onMenuHover(e) {
            if (e.target.nextElementSibling && e.target.classList.contains('worksends-menu-item-link') && !e.target.classList.contains('router-link-active')) {
                var rect = e.target.getBoundingClientRect();
                e.target.nextElementSibling.style.top = (rect.y+43)+"px";
            }
        },
        showTutorial(i) {
			/* if (this.tutorial != null) {
				return this.tutorial.enabled && (i === this.tutorial.currentStep);
			}
			return false; */
			return this.tutorial.enabled && (i === this.tutorial.currentStep);
        },
		onWindowResize() {
			if (
				window.innerWidth <= this.$store.state.sidebarBP
				&& this.windowWidth > window.innerWidth
				&& !this.sidebarShown
				&& this.tutorial.enabled === true
				&& this.tutorial.steps[this.tutorial.currentStep].inMenu === true
			) {
				this.toggleSidebar();
			}
			this.windowWidth = window.innerWidth;
		},
		toggleSidebar() {
			this.$root.$emit('bv::toggle::collapse', 'worksends-left-sidebar-toggle');
		}
    },
    computed: {
        teamSlug() {
            return this.$store.state.team.detail.slug;
        },
        currentUser() {
            return this.$store.state.currentUser;
        },
        coreLoaded() {
            return this.$store.state.coreLoaded;
        },
        campaignMenu() {
            return this.$store.state.giftBoxCampaign.menu;
        },
        /* tutorial() {
            return this.$store.state.tutorials[this.activeTutorial];
        }, */
		tutorial() {
            return this.$store.state.tutorials.marketplace;
        },
        team() {
            return this.$store.state.team.detail;
        },
        demo() {
            return this.$store.state.demo;
        },
		sidebarDisplayed() {
			return this.$store.state.sidebarDisplayed;
		},
		sidebarShown() {
			return this.$store.state.sidebarShown;
		},
		activeTutorial() {
			return this.$store.getters['tutorials/getActiveTutorial'];
		}
    },
    coreLoaded() {
        return this.$store.state.coreLoaded;
    },
	created() {
		window.addEventListener('resize', this.onWindowResize);
		this.$root.$on('bv::collapse::state', (id, show) => {
			this.$store.commit('sidebarShownChange', show);
		})
	},
	destroyed() {
		window.removeEventListener('resize', this.onWindowResize);
	},
};
</script>
